import { type FC } from 'react';
import { type InspirationIconsProps } from './types';

const CountrySide: FC<InspirationIconsProps> = ({ width, height, fill }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9102 7.89212H17.0477L12.5043 1.83825L10.4761 4.60037C10.4553 4.62529 10.4399 4.6542 10.4307 4.68531C10.4215 4.71642 10.4188 4.74908 10.4228 4.78127C10.4267 4.81347 10.4372 4.84451 10.4536 4.8725C10.47 4.90048 10.492 4.92481 10.5181 4.94398C10.5443 4.96316 10.5741 4.97677 10.6057 4.98398C10.6373 4.99119 10.6701 4.99185 10.702 4.98591C10.7339 4.97998 10.7642 4.96757 10.7911 4.94946C10.818 4.93136 10.8409 4.90793 10.8584 4.88062L12.5209 2.63387L16.0929 7.41712H13.9554L16.0929 10.2671H13.9554L16.0929 13.1171H14.0124V15.5871C14.0124 15.6501 14.0375 15.7105 14.082 15.7551C14.1266 15.7996 14.187 15.8246 14.2499 15.8246C14.3129 15.8246 14.3733 15.7996 14.4179 15.7551C14.4624 15.7105 14.4874 15.6501 14.4874 15.5871V13.5921H17.0406L14.9031 10.7421H17.0406L14.9102 7.89212Z"
      fill="#BAA57E"
    />
    <path
      d="M12.274 10.8253L9.5356 7.17013H11.2907L7.59998 2.242L3.90448 7.17013H5.66198L2.9236 10.8253H4.62885L1.95935 14.3878H6.29135V16.7628C6.29135 16.8257 6.31637 16.8862 6.36091 16.9307C6.40545 16.9752 6.46586 17.0003 6.52885 17.0003C6.59184 17.0003 6.65225 16.9752 6.69679 16.9307C6.74133 16.8862 6.76635 16.8257 6.76635 16.7628V13.9128H2.90698L5.57648 10.3503H3.87123L6.61198 6.69513H4.85448L7.59998 3.03288L10.3431 6.69513H8.5856L11.324 10.3503H9.61873L12.2906 13.9128H8.42885V16.7628C8.42885 16.8257 8.45387 16.8862 8.49841 16.9307C8.54295 16.9752 8.60336 17.0003 8.66635 17.0003C8.72934 17.0003 8.78975 16.9752 8.83429 16.9307C8.87883 16.8862 8.90385 16.8257 8.90385 16.7628V14.3878H13.2382L10.5687 10.8253H12.274Z"
      fill="#BAA57E"
    />
  </svg>
);

export default CountrySide;
